import { Link, useNavigate } from 'react-router-dom';
import HeaderOther from '../ui/header-other';
import './orders.css';
import { useContext, useEffect, useState } from 'react';
import { cartContext } from '../../App';

export default function Orders() {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false)
    const [statuses, setStatuses] = useState({});
    const navigate = useNavigate();
    const { userId } = useContext(cartContext);

    const isLoggedIn = userId ? true : false

    useEffect(() => {

        if (isLoggedIn) {
            const fetchOrders = async () => {
                setLoading(true);
                try {
                    const dataToSend = {
                        userId: userId,
                    };
                    const response = await fetch(`${BACKEND_URL}/get-user-orders`, {
                        method: "POST",
                        headers: {
                            'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(dataToSend),
                    });

                    const data = await response.json();
                    setOrders(data);
                } catch (err) {
                    alert("Error occurred while fetching orders");
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            };

            fetchOrders();

        } else {
            alert("Please log in to view your orders.");
            navigate('/login');
        }
    }, [isLoggedIn]); // Runs only when `isLoggedIn` changes

    // ⬇️ NEW useEffect to set statuses AFTER orders are updated
    useEffect(() => {
        if (orders.length > 0) {
            const updatedStatuses = {};
            orders.forEach((item) => {
                updatedStatuses[item.orderNumber] = item.status;
            });
            setStatuses(updatedStatuses);
        }
    }, [orders]); // Runs whenever `orders` is updated
    
    useEffect(() => {
        if (!isLoggedIn && orders.length > 0) {
            const fetchStatuses = async () => {
                try {
                    const updatedStatuses = {};
                    for (const order of orders) {
                        const response = await fetch(`${BACKEND_URL}/get-order-status`, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ orderNo: order.orderNumber }),
                        });
        
                        const data = await response.json();
                        updatedStatuses[order.orderNumber] = data.data; // Save status by order number
                    }
        
                    // Update statuses only if there's a change
                    setStatuses((prevStatuses) => {
                        const isSame = Object.keys(updatedStatuses).every(
                            (key) => prevStatuses[key] === updatedStatuses[key]
                        );
                        return isSame ? prevStatuses : updatedStatuses;
                    });
                } catch (err) {
                    console.error('Error fetching statuses:', err);
                }
            };
    
            fetchStatuses();
        }
    }, [orders, BACKEND_URL]); // Dependency array ensures it runs when orders change

    if (loading) {
        return (
            <>
                <HeaderOther title='My Orders' description='Order history'/>
                <div>
                    <div style={{display:'flex', flexDirection:'column' ,justifyContent:'center', alignItems:'center'}}>
                        <div className="spinner" style={{ borderLeftColor: '#2c5f2d', height: '30px', width: '30px' }}></div>
                        <p className='my-orders-heading' style={{color:'gray'}}>Fetching Orders</p>
                    </div>
                </div>
            </>
        );
    }
    


    if (orders.length === 0) {
        return (
            <>
                <HeaderOther />
                <p className='my-orders-heading' style={{ borderBottom: '0.15px solid gray', margin: '10px' }}>My Orders</p>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
                    <img src='/icons/no-order.png' alt='No Items in Cart' style={{height:'200px', width:'200px'}}/>
                    <p className='my-orders-heading' style={{ color: 'gray' }}>No Order Found</p>
                    <Link to='/' className='add-new-address'>START ORDERING</Link>
                </div>
            </>
        );
    }

    return (
        <>
            <HeaderOther title='My Orders' description='Order history'/>
            <div className='my-orders-container'>
                {
                    orders.slice().reverse().map((orderItem, index) => (
                        <Link key={index} to='/order-placed' state={{orderItem: orderItem, status: statuses[orderItem.orderNumber]}} style={{textDecoration:'none', color:'black'}}>
                            <div className='my-orders-box'>
                                <div className='my-orders-first-half'>
                                    <div className='my-orders-details'>
                                        <p className='my-orders-text' style={{fontWeight:'bold'}}>{ orderItem.orderTime }</p>
                                        <p className='my-orders-text'>Order No. { orderItem.orderNumber }</p>
                                    </div>
                                    <div className='my-orders-arrow'>
                                        <img src='/icons/right-arrow.png' alt='right-arrow' style={{height:'14px', width:'14px', marginRight:'5px'}}/>
                                    </div>
                                </div>
                                <div className='my-orders-second-half'>
                                    <div className='my-orders-total'>
                                        <p className='my-orders-text' style={{fontWeight:'bold'}}>Order Total: <span style={{fontFamily:'Arial'}}>&#8377;</span>{ orderItem.orderTotal}</p>
                                    </div>
                                    {
                                        statuses[orderItem.orderNumber] === 'Cancelled' ? (
                                            <div className='my-orders-status'>
                                                <p className='my-orders-text' style={{fontWeight:'bold', color:'rgb(186, 58, 58)'}}>{statuses[orderItem.orderNumber] || 'fetching'}</p>
                                            </div>
                                        ) : (
                                            <div className='my-orders-status'>
                                                <p className='my-orders-text' style={{fontWeight:'bold', color:'green'}}>{statuses[orderItem.orderNumber] || 'fetching'}</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </Link>
                    ))
                }
            </div>
        </>
        
    );

}


